/** Block types with an editable text area (focus targets) */
export const EDITABLE_TYPES = ['text', 'heading', 'checkbox', 'bullet', 'number', 'file-upload'];

/**
 * Types that participate in ArrowUp/ArrowDown / Left/Right block navigation.
 * Includes toggles (title is editable) but not other containers.
 */
export const NAVIGABLE_TYPES = [...EDITABLE_TYPES, 'toggle', 'choice'];

/** Types skipped when scanning the flat list for a text neighbour */
export const CONTAINER_TYPES = ['row', 'column', 'callout', 'toggle', 'choice', 'choice-path'];
